// Right-rail status cards: no-metadata/waiting counters.
import { Box } from '@mui/material';
import MoveToInboxOutlinedIcon from '@mui/icons-material/MoveToInboxOutlined';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { useNavigate } from 'react-router-dom';
import { StatBlock } from '@/components/ui/SharedComponents';
import { useT } from '@/i18n/useT';
import { usePlanRailStats } from '@/features/planning/hooks/use-plan-rail-stats';

export function PlanRailStats({ allTasks, tasksMap, showMetadata = true }) {
  const t = useT();
  const navigate = useNavigate();
  const { tasksWithoutMetadata, waitingTasks } = usePlanRailStats(
    allTasks,
    tasksMap,
  );

  return (
    <>
      {showMetadata && tasksWithoutMetadata.length > 0 ? (
        <StatBlock
          dense
          onClick={() => navigate('/app/organize?tab=inbox')}
          value={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.75,
              }}
            >
              <MoveToInboxOutlinedIcon
                sx={{ fontSize: 22, color: 'neutral.icon' }}
              />
              {tasksWithoutMetadata.length}
            </Box>
          }
          label={t('planpage.noMetadata', 'missen metadata')}
        />
      ) : null}
      {waitingTasks.length > 0 ? (
        <StatBlock
          dense
          onClick={() => navigate('/app/dashboard?tab=waiting')}
          value={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.75,
              }}
            >
              <HourglassEmptyIcon
                sx={{ fontSize: 22, color: 'neutral.icon' }}
              />
              {waitingTasks.length}
            </Box>
          }
          label={t('planpage.waitingOnSomeone', 'wachten op iemand')}
        />
      ) : null}
    </>
  );
}
